<template>
  <div>
    <div class="bg-black px-4 py-2 text-center text-white">
      <span>YOU ARE CURRENTLY VIEWING A PREVIEW VERSION OF THIS PAGE.</span>
    </div>
    <SkipToMain />
    <main id="main">
      <slot />
    </main>
  </div>
</template>

<script setup lang="ts">
const route = useRoute();
</script>
